import dateFnsFormat from "date-fns/format";
import { convertToLocalTime } from "date-fns-timezone";
import localizedStrings from "./localize";

export function isObjectEmpty(inputObject) {
  if (inputObject !== undefined) {
    // console.log(inputObject,"inputObject")
    return Object.keys(inputObject).length === 0;
  }
  return true;
}

export function dateFormatter(data) {
  var date = new Date(data);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
}

export function dateValueFormatter(data) {
  var date = new Date(data);
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "-" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
  );
}

export function isValidPathUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export function classStatusOptionList(value) {
  let optionSetClassStatus;
  if (value === "Available")
    optionSetClassStatus = localizedStrings.general.classStatusAvailable;
  if (value === "Full")
    optionSetClassStatus = localizedStrings.general.classStatusFull;
  if (value === "Wait List")
    optionSetClassStatus = localizedStrings.general.classStatusWaitList;
  if (value === "Cancelled")
    optionSetClassStatus = localizedStrings.general.classStatusCancelled;
  if (value === "Closed")
    optionSetClassStatus = localizedStrings.general.classStatusClosed;
  if (value === "Completed")
    optionSetClassStatus = localizedStrings.general.classStatusCompleted;
  return optionSetClassStatus;
}

export function statusOptionList(value) {
  let optionSetStatus;
  if (value === "Wait list")
    optionSetStatus = localizedStrings.general.StatusWaitList;
  if (value === "Enrolled")
    optionSetStatus = localizedStrings.general.StatusEnrolled;
  if (value === "Completed")
    optionSetStatus = localizedStrings.general.StatusCompleted;
  if (value === "Cancelled")
    optionSetStatus = localizedStrings.general.StatusCancelled;
  if (value === "Incomplete")
    optionSetStatus = localizedStrings.general.StatusIncomplete;
  if (value === "Dropped")
    optionSetStatus = localizedStrings.general.StatusDropped;
  if (value === "Tentative")
    optionSetStatus = localizedStrings.general.StatusTentative;
  if (value === "Transfer")
    optionSetStatus = localizedStrings.general.StatusTransfer;
  if (value === "Required to Withdraw")
    optionSetStatus = localizedStrings.general.StatusWithdraw;
  if (value === "Withdrawal")
    optionSetStatus = localizedStrings.general.StatusWithdrawal;
  return optionSetStatus;
}
export function paymentOptionList(value, pdf = false) {
  let optionSetPayment;
  if (value === "Cash") optionSetPayment = localizedStrings.general.paymentCash;
  if (value === "Check")
    optionSetPayment = localizedStrings.general.paymentCheck;
  if (value === "Credit")
    optionSetPayment = localizedStrings.general.paymentCredit;
  if (value === "Debit")
    optionSetPayment = localizedStrings.general.paymentDebit;
  if (value === "Online")
    optionSetPayment = localizedStrings.general.paymentOnline;
  if (value === "GlobalPay")
    optionSetPayment = localizedStrings.general.paymentGlobalPay;
  if (value === "Wire") optionSetPayment = localizedStrings.general.paymentWire;
  if (value === "Award")
    optionSetPayment = localizedStrings.general.paymentAward;
  if (value === "Electronic refund")
    optionSetPayment = localizedStrings.general.paymentElectronicrefund;
  if (value === "Refund by bank transfer")
    optionSetPayment = localizedStrings.general.paymentRefundbybanktransfer;
  if (
    pdf === false &&
    (value === "RF-EFT" || value === "RF-WIRE" || value === "RF-CC")
  )
    optionSetPayment = localizedStrings.general.reimbursement;
  if (pdf === true && value === "RF-EFT")
    optionSetPayment = localizedStrings.general.reimbursementeft;
  if (pdf === true && value === "RF-WIRE")
    optionSetPayment = localizedStrings.general.reimbursementwire;
  if (pdf === true && value === "RF-CC")
    optionSetPayment = localizedStrings.general.reimbursementcc;
  return optionSetPayment;
}

export function profileOptionList(value) {
  let optionSetProfile;
  if (value === "Male") optionSetProfile = localizedStrings.general.profileMale;
  if (value === "Female")
    optionSetProfile = localizedStrings.general.profileFemale;
  if (value === "Not Specified")
    optionSetProfile = localizedStrings.general.profileNotSpecified;
  if (value === "Undisclosed")
    optionSetProfile = localizedStrings.general.profileUndisclosed;
  if (value === "Non-binary")
    optionSetProfile = localizedStrings.general.profileNonbinary;
  if (value === "Agender")
    optionSetProfile = localizedStrings.general.profileAgender;
  if (value === "Bigender") optionSetProfile = "Bigender";
  if (value === "Genderfluid") optionSetProfile = "Genderfluid";
  if (value === "Genderqueer") optionSetProfile = "Genderqueer";
  if (value === "Polygender") optionSetProfile = "Polygender";
  if (value === "I prefer not to answer")
    optionSetProfile = "I prefer not to answer";

  return optionSetProfile;
}

export function selectClassOptionList(value) {
  let optionSetSelectClass;
  if (value === "Grade")
    optionSetSelectClass = localizedStrings.general.selectClassGrade;
  if (value === "Pass/Fail")
    optionSetSelectClass = localizedStrings.general.selectClassPassFail;
  if (value === "Audit")
    optionSetSelectClass = localizedStrings.general.selectClassAudit;
  if (value === "Award")
    optionSetSelectClass = localizedStrings.general.selectClassAward;
  return optionSetSelectClass;
}

export function applicationStatusOptionList(value) {
  let optionSetApplicationStatus;
  if (value === "Started")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.started;
  if (value === "Submitted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.submitted;
  if (value === "Action Required")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.actionrequired;
  if (value === "Ongoing Evaluation")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.ongoingevaluation;
  if (value === "Conditional Offer")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.conditionaloffer;
  if (value === "Official Acceptance")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.officialacceptance;
  if (value === "Rejected")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.rejected;
  if (value === "Inactive")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.inactive;
  if (value === "Offer Accepted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.offeraccepted;
  if (value === "Matriculant")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.matriculant;
  if (value === "Student")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.student;
  if (value === "Cancelled")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.cancelled;
  if (value === "Waitlisted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.waitlisted;
  if (value === "Pre-Matriculant")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.prematriculant; 
    if (value === "No Show")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.noShow;   
  return optionSetApplicationStatus;
}

export function getYear() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 26 }, (_, i) => {
    const year = currentYear - i;
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export function getStartYearRange() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 61 }, (_, i) => {
    const year = currentYear - i;
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export function getEndYearRange() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 60; // 60 years in the past
  const endYear = currentYear + 2; // 2 years in the future

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = endYear - i; // Start from endYear and decrement
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";

/**
 * Format a date to a string
 *
 * @param date
 */
// export const formatDate = (date) => {
//   // Check for invalid date
//   const parsedDate = new Date(date);
//   if (isNaN(parsedDate)) {
//     return "Invalid Date";
//   }

//   // Get the timezone from browser using native methods
//   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   // Convert to local date in the specified timezone
//   const localDate = convertToLocalTime(parsedDate, { timeZone: timezone });

//   // Format the local date
//   return dateFnsFormat(localDate, DEFAULT_DATE_FORMAT);
// };
export const formatDate = (date) => {
  if (!date) return "Invalid Date";

  // If already in YYYY-MM-DD, return as-is to preserve the entered calendar day
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) {
    return "Invalid Date";
  }

  // Format using UTC components to avoid timezone day-shift
  const year = parsedDate.getUTCFullYear();
  const month = String(parsedDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const formatDateTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

/**
 * Parse a database date string (stored in CT, no timezone info) as CT time
 * Database dates like "2026-01-14T23:59:00" are stored in CT but have no timezone indicator
 * This function converts them to a proper Date object representing that CT time
 * @param {string} dateString - Date string from database (e.g., "2026-01-14T23:59:00")
 * @returns {Date} Date object representing the CT time
 */
export const parseDatabaseDateAsCT = (dateString) => {
  if (!dateString) return null;
  
  const CT_TIMEZONE = "America/Chicago";
  
  // Parse the date string to get components (these are CT time components)
  // Format is typically "YYYY-MM-DDTHH:mm:ss" or "YYYY-MM-DDTHH:mm:ss.sss"
  const dateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?/);
  if (!dateMatch) {
    // Fallback to standard Date parsing if format doesn't match
    return new Date(dateString);
  }
  
  const [, year, month, day, hour, minute, second, millisecond] = dateMatch;
  const yearNum = parseInt(year);
  const monthNum = parseInt(month) - 1; // 0-indexed
  const dayNum = parseInt(day);
  const hourNum = parseInt(hour);
  const minuteNum = parseInt(minute);
  const secondNum = parseInt(second);
  const millisecondNum = millisecond ? parseInt(millisecond.padEnd(3, "0")) : 0;
  
  // To find the UTC timestamp for this CT time, we need to:
  // 1. Start with a UTC timestamp that's close to our target
  // 2. Use Intl to see what CT time it represents
  // 3. Calculate the difference and adjust
  
  // Create a UTC timestamp assuming the CT components were UTC (as a starting point)
  const approximateUTC = Date.UTC(yearNum, monthNum, dayNum, hourNum, minuteNum, secondNum, millisecondNum);
  const testDate = new Date(approximateUTC);
  
  // Get CT formatter
  const ctFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: CT_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  
  // Get what CT time this approximate UTC timestamp represents
  const ctParts = ctFormatter.formatToParts(testDate);
  const ctYear = parseInt(ctParts.find(p => p.type === "year").value);
  const ctMonth = parseInt(ctParts.find(p => p.type === "month").value) - 1;
  const ctDay = parseInt(ctParts.find(p => p.type === "day").value);
  const ctHour = parseInt(ctParts.find(p => p.type === "hour").value);
  const ctMinute = parseInt(ctParts.find(p => p.type === "minute").value);
  const ctSecond = parseInt(ctParts.find(p => p.type === "second").value);
  
  // Create UTC timestamp for what CT time the approximate UTC represents
  const ctRepresentationAsUTC = Date.UTC(ctYear, ctMonth, ctDay, ctHour, ctMinute, ctSecond);
  
  // Calculate the offset: how much does CT differ from UTC for this date?
  // If approximateUTC represents a CT time that's different from our target, we adjust
  const offsetMs = approximateUTC - ctRepresentationAsUTC;
  
  // Now create UTC timestamp for our target CT components
  const targetCTAsUTC = Date.UTC(yearNum, monthNum, dayNum, hourNum, minuteNum, secondNum, millisecondNum);
  
  // Adjust by the offset to get the correct UTC timestamp
  // This gives us the UTC time that corresponds to our CT time
  const correctUTCTimestamp = targetCTAsUTC + offsetMs;
  
  return new Date(correctUTCTimestamp);
};

/**
 * Get the current date and time in Central Time (CT) timezone
 * USB always works in CT, so we need to compare dates in CT timezone
 * This function gets what time it is RIGHT NOW in CT and returns it
 * as a comparable timestamp for comparison with database dates in CT
 * @returns {Date} Date object representing current time in CT
 */
export const getCurrentDateTimeInCT = () => {
  const now = new Date();
  // Central Time timezone identifier
  const CT_TIMEZONE = "America/Chicago";
  
  // Get the current time components in CT
  const ctFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: CT_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  
  const ctDateParts = ctFormatter.formatToParts(now);
  const ctYear = parseInt(ctDateParts.find(p => p.type === "year").value);
  const ctMonth = parseInt(ctDateParts.find(p => p.type === "month").value) - 1; // 0-indexed for Date constructor
  const ctDay = parseInt(ctDateParts.find(p => p.type === "day").value);
  const ctHour = parseInt(ctDateParts.find(p => p.type === "hour").value);
  const ctMinute = parseInt(ctDateParts.find(p => p.type === "minute").value);
  const ctSecond = parseInt(ctDateParts.find(p => p.type === "second").value);
  
  // Get the current UTC time
  const currentUTC = now.getTime();
  
  // Create a UTC timestamp assuming the CT components were UTC
  const ctAsIfUTC = Date.UTC(ctYear, ctMonth, ctDay, ctHour, ctMinute, ctSecond);
  
  // Calculate the offset: difference between actual UTC and CT-as-if-UTC
  // This tells us how much CT is offset from UTC
  const ctOffsetMs = currentUTC - ctAsIfUTC;
  
  // Adjust by the offset to get the correct UTC timestamp
  const correctUTCTimestamp = ctAsIfUTC + ctOffsetMs;
  
  return new Date(correctUTCTimestamp);
};